module.exports = __webpack_public_path__ + "img/camera.e836b900.svg";